module.exports = __webpack_public_path__ + "static/fighting-infernos-before-they-start-d4f44bce6abc9161fcdb10cf369519d1.jpg";